import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { FormError } from '@ds/react-components';
import moment from 'moment';

import * as Styled from './NoticePeriod.styled';

const NoticePeriod = (props) => {
  const {
    cancelDaysNotice,
    formControl,
    isSubmittingForm,
    dateDisplayFormat,
    noticeErrors,
  } = props;

  // If the cancel days is zero this option is still shown.
  const maxPastDate = useMemo(
    () =>
      cancelDaysNotice === 0
        ? moment()
        : moment().subtract(cancelDaysNotice, 'days').add(1, 'days'), //Includes the start date as a notice day as well.
    [cancelDaysNotice]
  );

  const getInvalidDateMessage = () =>
    `Please select a date from ${maxPastDate.format(
      dateDisplayFormat
    )}  to ${moment().format(dateDisplayFormat)}`;

  return (
    <Styled.NoticePeriodWrapper>
      <Controller
        name={'noticeStartDate'}
        control={formControl}
        rules={{
          required: 'Please select a date',
          validate: {
            validDate: (value) => value.isValid() || getInvalidDateMessage(),
            notInFuture: (value) =>
              value.isSameOrBefore(moment(), 'days') || getInvalidDateMessage(),
            greaterThanMaxPastDate: (value) =>
              value.isSameOrAfter(maxPastDate, 'days') ||
              getInvalidDateMessage(),
          },
        }}
        render={({ onChange, value, onBlur }) => (
          <Styled.NoticePeriodStartDatePicker
            value={value}
            placeholder={dateDisplayFormat}
            disableFuture={true}
            onChange={onChange}
            format={dateDisplayFormat}
            disabled={isSubmittingForm || cancelDaysNotice === 0}
            label={'Start notice period on'}
            labelId={'startNotice'}
            error={!!noticeErrors}
            onClose={onBlur}
            minDate={maxPastDate}
            invalidDateMessage={'Please enter a valid date.'}
            onBlur={onBlur}
          />
        )}
      />
      {noticeErrors && noticeErrors.message && (
        <FormError>{noticeErrors.message}</FormError>
      )}
    </Styled.NoticePeriodWrapper>
  );
};

NoticePeriod.propTypes = {
  cancelDaysNotice: PropTypes.number.isRequired,
  formControl: PropTypes.object.isRequired,
  isSubmittingForm: PropTypes.bool.isRequired,
  dateDisplayFormat: PropTypes.string.isRequired,
  noticeErrors: PropTypes.object,
  dataTestId: PropTypes.string,
};

NoticePeriod.defaultProps = {
  dataTestId: 'cancel-form-notice-period',
};

export default NoticePeriod;
